import * as Yup from "yup";

const AddTestimonialSchema = Yup.object().shape({
    customerName: Yup.string().required("Required"),
    message: Yup.string().required("Required"),
  });

  export {AddTestimonialSchema};